let baseUrl = '';
const env = process.env

// https://airportcanteen.hengyudata.com 测试
// https://digitalcanteen.api.hengyudata.com 正式
// https://jxc.dc.hengyudata.com 单门店正式
// http://localhost:7880
if (env.NODE_ENV === 'development') {
    baseUrl = `http://localhost:7880`; // 开发环境地址
} else if (env.NODE_ENV === 'production') {
    baseUrl = `https://jxc.dc.hengyudata.com`; //生产环境地址
} else if (env.NODE_ENV === 'test') {
    baseUrl = `http://192.168.2.48:7880`; //测试环境地址
}
export {
    baseUrl,
    env
}
